//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Object.js";
import "../no/ugmath.js";
import "../no/Part.js";
let d=[[],[[["follow_curve","start_rcp","end_rcp","user_defined"],"CreateSegmentOnFollowCurve",{R_:{new_segment:"Routing.ISegment"}},4,0],[["start_rcp","end_rcp"],"CreateSegmentThroughRcps",{R_:{new_segment:"Routing.ISegment"}},2,0],[["segment","follow_curve"],"SetFollowCurve",{R_:{modified_segment:"Routing.ISegment"}},2,0],[["segments","do_update","n_new_segments","new_segments"],"SimplifySegments",{},2,0],[["segment","subdivide_option","n_subdivide_segments","subdivide_segments"],"Subdivide",{},2,0],[["start_rcp","end_rcp"],"CreateConstrainedSegment",{R_:{new_segment:"Routing.ISegment"}},2,0],[["start_object","end_object","heal_path"],"CreateHealSpline",{R_:{new_segment:"Routing.ISegment"}},3,0],[[],"CreateHealPath",{R_:{heal_path:"Routing.HealPath"}},0,0],[["multi_port","cut_back_length","extension_string","override_charx","terminal_ports"],"ModelTerminals",{},5,0],[["multi_port","terminal_ports"],"UnmodelTerminals",{},2,0],[["part_occ"],"ProcessBuiltInPaths",{},1,0],[["controlPoint1","controlPoint2","nSegments"],"GetShortestPathBetweenControlPoints",{R_:{segments:"Routing.ISegment[]"}},2,0],[["splineSegment"],"CreateSplineData",{R_:{splineData:"Routing.SplineData"}},1,0],[["positions"],"CreateSplineData1",{R_:{splineData:"Routing.SplineData"}},1,0],[["segment1","segment2","controlPoint"],"AreSegmentsTangent",{R_:{areSegmentsTangent:''}},3,0]],[["Segments","Routing.ISegmentCollection",0],["LineSegments","Routing.LineSegmentCollection",0],["ArcSegments","Routing.ArcSegmentCollection",0],["SplineSegments","Routing.SplineSegmentCollection",0]]];
SPLM.Routing.SegmentManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.SegmentManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.SegmentManager.SubdivideOption = class{
    constructor(spacing_option,start_percent,end_percent,screen_point_percentage,direction,number_of_segments,geometric_ratio,incremental_arc_length,chordal_tolerance,dcm3CreateTangency,dcm3AddPoints,dcm3AddFixConstraint){
        this.spacing_option=spacing_option;this.start_percent=start_percent;this.end_percent=end_percent;this.screen_point_percentage=screen_point_percentage;this.direction=direction;this.number_of_segments=number_of_segments;this.geometric_ratio=geometric_ratio;this.incremental_arc_length=incremental_arc_length;this.chordal_tolerance=chordal_tolerance;this.dcm3CreateTangency=dcm3CreateTangency;this.dcm3AddPoints=dcm3AddPoints;this.dcm3AddFixConstraint=dcm3AddFixConstraint;}
    get SpacingOption(){return this.spacing_option}
    set SpacingOption(val){this.spacing_option = val}
    get StartPercent(){return this.start_percent}
    set StartPercent(val){this.start_percent = val}
    get EndPercent(){return this.end_percent}
    set EndPercent(val){this.end_percent = val}
    get ScreenPointPercentage(){return this.screen_point_percentage}
    set ScreenPointPercentage(val){this.screen_point_percentage = val}
    get Direction(){return this.direction}
    set Direction(val){this.direction = val}
    get NumberOfSegments(){return this.number_of_segments}
    set NumberOfSegments(val){this.number_of_segments = val}
    get GeometricRatio(){return this.geometric_ratio}
    set GeometricRatio(val){this.geometric_ratio = val}
    get IncrementalArcLength(){return this.incremental_arc_length}
    set IncrementalArcLength(val){this.incremental_arc_length = val}
    get ChordalTolerance(){return this.chordal_tolerance}
    set ChordalTolerance(val){this.chordal_tolerance = val}
    get Dcm3createtangency(){return this.dcm3CreateTangency}
    set Dcm3createtangency(val){this.dcm3CreateTangency = val}
    get Dcm3addpoints(){return this.dcm3AddPoints}
    set Dcm3addpoints(val){this.dcm3AddPoints = val}
    get Dcm3addfixconstraint(){return this.dcm3AddFixConstraint}
    set Dcm3addfixconstraint(val){this.dcm3AddFixConstraint = val}
};

SPLM.Routing.UserDefined = Object.freeze({
    "NotUserDefined" : "NotUserDefined", "UserDefined" : "UserDefined"});

SPLM.Routing.Terminal = Object.freeze({
    "NotTerminalSeg" : "NotTerminalSeg", "TerminalSeg" : "TerminalSeg"});

SPLM.Routing.Interior = Object.freeze({
    "NotInteriorToPart" : "NotInteriorToPart", "InteriorToPart" : "InteriorToPart"});

SPLM.Routing.Eccentric = Object.freeze({
    "NotEccentricSeg" : "NotEccentricSeg", "EccentricSeg" : "EccentricSeg"});

SPLM.Routing.ConvertLinearToEccentricLinear = Object.freeze({
    "NotConverted" : "NotConverted", "Converted" : "Converted"});

SPLM.Routing.ConvertEccentricLinearToLinear = Object.freeze({
    "NotConverted" : "NotConverted", "Converted" : "Converted"});

SPLM.Routing.SegmentManager.SubdivideSpacing = Object.freeze({
    "ScreenPoint" : "ScreenPoint", "EqualArcLength" : "EqualArcLength", "EqualParameter" : "EqualParameter", "IncrementalArcLength" : "IncrementalArcLength", "GeometricRatio" : "GeometricRatio", "ChordalTolerance" : "ChordalTolerance", "NumberOfOptions" : "NumberOfOptions"});

export default SPLM;